import React from "react";
import { Field } from "react-final-form";
import { SearchAlgoliaIndex } from "@govlaunch/algolia";
import { StoryProductSelect } from "@govlaunch/select";
import { useIntl } from "react-intl";

export default function ProductsField() {
  const intl = useIntl();

  return (
    <Field name="products" allowNull={true}>
      {({ input }) => (
        <div css={{ padding: 15 }}>
          <SearchAlgoliaIndex index="products">
            {({ results: products, searchValue: inputValue, onChange: onInputValueChange }: any) => (
              <StoryProductSelect
                placeholder={intl.formatMessage({ defaultMessage: "Type product names", id: "hJ0uBD" })}
                autoFocus={false}
                products={Array.isArray(input.value) ? input.value : []}
                inputValue={inputValue}
                onInputValueChange={onInputValueChange}
                selectableProducts={products}
                onChange={input.onChange}
                onFocus={input.onFocus}
                onBlur={input.onBlur}
                css={{
                  minWidth: "auto !important",
                  zIndex: "999 !important",
                }}
              />
            )}
          </SearchAlgoliaIndex>
        </div>
      )}
    </Field>
  );
}
